export const CLASS_ACTIONS = {
  SET_STATE: "class/setState",
  GET_CLASS: "class/getClass",
  GET_CLASS_BY_ID: "class/getClassById",
  CREATE_CLASS: "class/createClass",
  UPDATE_CLASS: "class/updateClass",
  DELETE_CLASS: "class/deleteClass",
};
